import { Component } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { Router, ActivatedRoute } from "@angular/router";
import {
  LEVEL_PUBLISHED,
  PARAM_CATEGORIES_PATH,
  PARAM_CLIENTS_PATH,
  PARAM_NEWS_PATH,
  PARAM_PAGES_PATH,
  STATE_PUBLISHED,
} from "src/app/admin/constants/constants";
import { Clients } from "src/app/models/clients";
import { News } from "src/app/models/news";
import { AbstractListController } from "src/app/common/abstract-list.component";
import { NewsService } from "src/app/services/news.service";
import { environment } from "src/environments/environment";

import { DynamicFiltersComponent } from "src/app/components/dynamic-filters/dynamic-filters.component";
import { ButtonModule } from "primeng/button";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { DrawerModule } from "primeng/drawer";
import { SharedModule } from "primeng/api";
import { FormsModule } from "@angular/forms";
import { InputTextModule } from "primeng/inputtext";
import { NgxPaginationModule } from "ngx-pagination";
import { Ripple } from "primeng/ripple";
import { RouterLink } from "@angular/router";
import { SelectModule } from "primeng/select";
import { TableModule } from "primeng/table";
import { TagModule } from "primeng/tag";
import { ToastModule } from "primeng/toast";
import { TopNavComponent } from "../../../top-nav/top-nav.component";

@Component({
    selector: "app-manage-news",
    templateUrl: "./manage-news.component.html",
    imports: [DynamicFiltersComponent, ButtonModule, ConfirmDialogModule, DrawerModule, SharedModule, FormsModule, InputTextModule, NgxPaginationModule, Ripple, RouterLink, SelectModule, TableModule, TagModule, ToastModule, TopNavComponent]
})
export class ManageNewsComponent extends AbstractListController<News, any> {
  title = "News";
  imageUrl: string;
  pages: News[];
  pageUrl = PARAM_NEWS_PATH;

  constructor(
    protected newsService: NewsService,
    protected confirmationService: ConfirmationService,
    router: Router,
    route: ActivatedRoute
  ) {
    super(newsService, confirmationService, router, route, PARAM_NEWS_PATH);
    this.imageUrl = environment.news_image_url;

    this.cols.set([
      { field: "page_title", header: "Titolo" },
      { field: "page_template", header: "Tipo" },
      { field: "is_active", header: "Attivo" },
      { field: "is_featured", header: "Featured" },
    ])

    this.colsFilter.set([
      { field: "page_title", header: "Titolo", type: "string" },
    ])


    this.setupDynamicFilters();
  }



}
